module.exports = __webpack_public_path__ + "static/media/menuIcon.0c765710.svg";